<template>
  <div>
    <OrderTable
      ref="orderTable"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        perfect
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </OrderTable>
  </div>
</template>

<script>
import OrderTable from './table.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageHeader, OrderTable },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentPayStatementBookingOptionalApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
